
import React from "react";
import {
  useQuery,
  useMutation,
  useLazyQuery,
} from "@apollo/react-hooks";
import gql from "graphql-tag";
import { Loading, ConfirmReserveForm, ChooseLease } from "../components";
import Typography from "@material-ui/core/Typography";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js/pure";
import LeaseHighlights from "../components/lease-highlights";
import { makeStyles, Box } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  reserveHeading: { marginBottom: 6 },
  narrowPageBox: theme.narrowPageBox,
}))

// loadStripe.setLoadParameters({ advancedFraudSignals: false });
const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY);

export const GET_CARTLEASE_CARTCAR = gql`
  query getCartLeaseCartCar {
    cartCar @client {
      vin
      year
      make
      model
      images
    }
    cartLease @client {
      __typename
      pickupLocation
      dropoffLocation
      transportCost
      secondLegFee
      dropoffLegFee
      leaseTotal
      firstMonthSalesTax
      firstMonthRentalTax
      monthlySalesTax
      monthlyRentalTax
      proration
      dropoffLegSalesTax
      dropoffLegRentalTax
      paymentsTotal
      leaseFirst
      leaseMonthly
      customerPickupDate
      customerLeaseMonths
      vin
      yearMakeModel
      insuranceMonthly
      insuranceAccuracy
      customerTaxRate
      taxRateAccuracy
      customerState
      stateAccuracy
      createdDate
    }
    customerPickupDate @client
  }
`;

export const GET_CARTLEASE = gql`
  query cartLease @client {
    __typename
    pickupLocation
    dropoffLocation
    transportCost
    secondLegFee
    dropoffLegFee
    leaseTotal
    firstMonthSalesTax
    firstMonthRentalTax
    monthlySalesTax
    monthlyRentalTax
    proration
    dropoffLegSalesTax
    dropoffLegRentalTax
    paymentsTotal
    leaseFirst
    leaseMonthly
    customerPickupDate
    customerLeaseMonths
    vin
    yearMakeModel
    insuranceMonthly
    insuranceAccuracy
    customerTaxRate
    taxRateAccuracy
    customerState
    stateAccuracy
    createdDate
  }
  
`;

export const GET_CARTLEASE_CARTCAR_CUSTOMER = gql`
  query getCartLeaseCartCarCustomer {
    cartLease @client {
      pickupLocation
      dropoffLocation
      transportCost
      secondLegFee
      dropoffLegFee
      leaseTotal
      firstMonthSalesTax
      firstMonthRentalTax
      monthlySalesTax
      monthlyRentalTax
      proration
      dropoffLegSalesTax
      dropoffLegRentalTax
      paymentsTotal
      leaseFirst
      leaseMonthly
      customerPickupDate
      customerLeaseMonths
      vin
      yearMakeModel
      insuranceMonthly
      insuranceAccuracy
      customerTaxRate
      taxRateAccuracy
      customerState
      stateAccuracy
      createdDate
    }
    cartCar @client {
      vin
      year
      make
      model
      trim
      drivetrain
      type
      size
      mileage
      location
      leaseFirst
      leaseMonthly
      images
    }
    customerPickupDate @client
    customerLeaseMonths @client
    customerTaxRate @client
    taxRateAccuracy @client
    customerState @client
    stateAccuracy @client
  }
`;

// export const LOAD_LEASEQUOTE = gql`
//   mutation loadLeaseQuote($quoteId: ID!) {
//     loadLeaseQuote(quoteId: $quoteId) @client
//   }
// `;

export const GET_LEASEQUOTE = gql`
  query leaseQuote($quoteId: ID!) {
    leaseQuote(quoteId: $quoteId) {
      pickupLocation
      dropoffLocation
      transportCost
      secondLegFee
      dropoffLegFee
      leaseTotal
      firstMonthSalesTax
      firstMonthRentalTax
      monthlySalesTax
      monthlyRentalTax
      proration
      dropoffLegSalesTax
      dropoffLegRentalTax
      paymentsTotal
      leaseFirst
      leaseMonthly
      customerPickupDate
      customerLeaseMonths
      vin
      yearMakeModel
      insuranceMonthly
      insuranceAccuracy
      customerTaxRate
      taxRateAccuracy
      customerState
      stateAccuracy
      createdDate
    }
  }
`;

export const UPDATE_CARTLEASE = gql`
  mutation updateCartLease($cartLeaseUpdates: Lease!) {
    updateCartLease(cartLeaseUpdates: $cartLeaseUpdates) @client
  }
`;

export default function ReserveConfirm({ "*": quoteId }) {
  const classes = useStyles();
  const { data, loading, error } = useQuery(GET_CARTLEASE_CARTCAR, {
    // fetchPolicy: "network-only",
  });

  // const [
  //   loadLeaseQuote,
  //   { loading: leaseQuoteLoading, error: leaseQuoteError },
  // ] = useMutation(LOAD_LEASEQUOTE, {
  //   variables: { quoteId },
  //   onCompleted({ loadLeaseQuote }) {
  //     debugger;
  //     console.log("loadLeaseQuote onCompleted");
  //   },
  // });

  const [
    updateCartLease,
    { loading: cartLeaseLoading, error: cartLeaseError },
  ] = useMutation(UPDATE_CARTLEASE, {
    // strip back all these refetches/updates in both mutation functions now that we know what the issue was
    refetchQueries: [{ query: GET_CARTLEASE_CARTCAR }],
    awaitRefetchQueries: true,
    onCompleted({ updateCartLease }) {
      console.log("updateCartLease completed");
      console.log(updateCartLease);
    },
    update(cache, { data: { updateCartLease } }) {
      cache.writeQuery({
        query: GET_CARTLEASE,
        data: { cartLease: updateCartLease.cartLease },
      });
      // const { todos } = cache.readQuery({ query: GET_TODOS });
      // cache.writeQuery({
      //   query: GET_TODOS,
      //   data: { todos: todos.concat([addTodo]) },
      // });
      console.log("update updateCartLease");
      console.log(updateCartLease);
    },
  });

  // debug, doesn't look like GET_LEASEQUOTE is actually running
  const [
    getLeaseQuoteLoad,
    { loading: getLeaseQuoteLoading, data: getLeaseQuoteError },
  ] = useLazyQuery(GET_LEASEQUOTE, {
    // variables: { quoteId },
    // refetchQueries: [{ query: GET_CARTLEASE_CARTCAR }],
    // awaitRefetchQueries: true,
    onCompleted({ leaseQuote }) {
      console.log("getLeaseQuote onCompleted");
      console.log(leaseQuote);
      // client.writeData({
      //   data: {
      //     cartLease: { pickupLocation: leaseQuote.pickupLocation },
      //   },
      // });
      const updateResponse = updateCartLease({
        variables: { cartLeaseUpdates: leaseQuote },
      });
      console.log("updateResponse");
      console.log(updateResponse);
    },
  });

  const [isQuoteLoaded, setIsQuoteLoaded] = React.useState(false);

  // const handleReserveClick = event => {
  //   event.preventDefault();
  //   client.writeData({ data: { cart: vin } });
  // };

  if (loading) return <Loading />;
  if (error) return <p>ERROR: {error.message}</p>;

  console.log("quoteId");
  console.log(quoteId);

  console.log("stripe");
  console.log(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY);

  // if the car's available

  if (!data.cartLease.vin && !quoteId) return <ChooseLease />;
  if (!data.cartLease.vin && !isQuoteLoaded) {
    // check into using .called on useLazyQuery here instead of isQuoteLoaded
    console.log("loadLeaseQuote");
    getLeaseQuoteLoad({ variables: { quoteId } });
    setIsQuoteLoaded(true);
  }

  if (!data.cartLease.vin) return <ChooseLease />;

  return (
    <Box className={classes.narrowPageBox}>
      <Typography variant="h5" className={classes.reserveHeading}>Confirm and reserve</Typography>
      <LeaseHighlights lease={data.cartLease} image={data.cartCar.images[0]} />
      <Elements stripe={stripePromise}>
        <ConfirmReserveForm lease={data.cartLease} />
      </Elements>
    </Box>
  );
}
